import Vue from 'vue'

import {BootstrapVue, IconsPlugin} from 'bootstrap-vue'
import '../scss/custom.scss'

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
